module.exports = __webpack_public_path__ + "static/fonts/Sarabun-Regular.d158001.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Sarabun-Regular.eot
// module id = 0gH7
// module chunks = 8